/**
 * <related-products>
 * ---------------------------------------------------------------------------
 * Carga las recomendaciones de Shopify en diferido.
 *
 * Por qué en diferido y no en el render inicial: las recomendaciones están al
 * final de la ficha, donde casi nadie llega de inmediato. Pedirlas al cargar
 * haría competir esas imágenes con la foto principal del producto, que es el
 * LCP de la página. Se piden cuando el bloque se acerca a la pantalla.
 *
 * Si la petición falla, el bloque se queda vacío y `.related:empty` lo oculta.
 * Nunca aparece un hueco ni un mensaje de error por unas recomendaciones.
 */

class RelatedProducts extends HTMLElement {
  connectedCallback() {
    // Ya viene renderizado del servidor (por ejemplo, tras un theme editor render)
    if (this.querySelector('.related__list')) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        this.#load();
      },
      { rootMargin: '400px' } // arranca antes de que se vea, para que llegue a tiempo
    );

    observer.observe(this);
  }

  async #load() {
    try {
      const url = `${this.dataset.url}&intent=${this.dataset.intent ?? 'related'}`;
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const fresh = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('related-products');

      if (fresh) this.innerHTML = fresh.innerHTML;
    } catch (error) {
      console.error('[related-products] No se pudieron cargar las recomendaciones.', error);
      // Se deja vacío a propósito: `.related:empty { display: none }` lo oculta
    }
  }
}

if (!customElements.get('related-products')) {
  customElements.define('related-products', RelatedProducts);
}
